module.exports = __webpack_public_path__ + "static/img/23.8a32954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/23.png
// module id = Fn7x
// module chunks = 0